// client/src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { io } from "socket.io-client";

const AuthContext = createContext();
const SOCKET_URL = process.env.REACT_APP_API_URL;
let socket = null;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // will store full shaped user
  const [loading, setLoading] = useState(true);

  const attachSocket = (userData) => {
    try {
      if (socket) socket.disconnect();
      socket = io(SOCKET_URL);
      socket.on("connect", () => {
        // use userData.id (server sends id as string)
        socket.emit("auth", { userId: userData.id });
      });
      socket.on("disconnect", () => {});
    } catch (err) {
      console.error("Socket attach error:", err);
    }
  };

  const refreshUser = async () => {
    const token = localStorage.getItem("cp_token");
    if (!token) {
      setUser(null);
      return null;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.user) {
        setUser(data.user);
        attachSocket(data.user);
        return data.user;
      } else {
        localStorage.removeItem("cp_token");
        setUser(null);
        return null;
      }
    } catch (err) {
      console.error("refreshUser error:", err);
      return null;
    }
  };

  // Auto-login using token
  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("cp_token");
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (res.ok && data.user) {
          setUser(data.user);
          attachSocket(data.user);
        } else {
          localStorage.removeItem("cp_token");
          setUser(null);
        }
      } catch (err) {
        console.error("Auth me error:", err);
        localStorage.removeItem("cp_token");
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
    // cleanup socket on unmount
    return () => {
      if (socket) socket.disconnect();
    };
  }, []);

  const login = (userData, token) => {
    // userData should be the shaped full user (server response)
    localStorage.setItem("cp_token", token);
    setUser(userData);
    attachSocket(userData);
  };

  const logout = () => {
    localStorage.removeItem("cp_token");
    setUser(null);
    if (socket) socket.disconnect();
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
